function getLastElementOfArray(arr: any[]) {
  if (arr.length === 0) return undefined;
  return arr[arr.length - 1];
}

export default getLastElementOfArray;
